<template>
  <div class="app-layout">
    <!-- 侧边栏 -->
    <aside class="sidebar" :class="{ 'sidebar-collapsed': isCollapsed }">
      <div class="logo-area">
        <img :src="shopLogo" alt="logo" class="logo-img" />
        <span class="logo-text" v-show="!isCollapsed">{{ shopName }}</span>
      </div>

      <div class="sidebar-menu-wrapper">
        <el-menu :default-active="activeMenu" :collapse="isCollapsed" :collapse-transition="false" router
          class="sidebar-menu">

          <!-- 1. 数据看板 (始终显示) -->
          <el-menu-item index="/dashboard">
            <el-icon>
              <Odometer />
            </el-icon>
            <span>数据看板</span>
          </el-menu-item>

          <!-- 2. 门店管理 (始终显示) -->
          <el-sub-menu index="store-group">
            <template #title>
              <el-icon>
                <Shop />
              </el-icon>
              <span>门店管理</span>
            </template>
            <el-menu-item index="/store">
              <el-icon>
                <House />
              </el-icon>
              <span>门店列表</span>
            </el-menu-item>
            <el-menu-item index="/store-branch">
              <el-icon>
                <Share />
              </el-icon>
              <span>分店管理</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 3. 商品管理 (始终显示) -->
          <el-sub-menu index="product-group">
            <template #title>
              <el-icon>
                <Goods />
              </el-icon>
              <span>商品管理</span>
            </template>
            <el-menu-item index="/product/category">
              <el-icon>
                <Collection />
              </el-icon>
              <span>商品分类</span>
            </el-menu-item>
            <el-menu-item index="/product/list">
              <el-icon>
                <List />
              </el-icon>
              <span>商品列表</span>
            </el-menu-item>
            <el-menu-item index="/product/add">
              <el-icon>
                <Plus />
              </el-icon>
              <span>添加商品</span>
            </el-menu-item>
            <el-menu-item index="/product-spec">
              <el-icon>
                <Setting />
              </el-icon>
              <span>商品规格</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 4. 订单管理 (始终显示) -->
          <el-menu-item index="/order">
            <el-icon>
              <Document />
            </el-icon>
            <span>订单管理</span>
          </el-menu-item>

          <!-- 5. 核销记录 (始终显示) -->
          <el-menu-item index="/verification-record">
            <el-icon>
              <Checked />
            </el-icon>
            <span>核销记录</span>
          </el-menu-item>

          <!-- 6. 矩阵管理 (需要 group_buy_mini_pro_video_jz 授权) -->
          <el-sub-menu index="matrix-group" v-if="pluginAuth.video_jz">
            <template #title>
              <el-icon>
                <Grid />
              </el-icon>
              <span>矩阵管理</span>
            </template>
            <el-menu-item index="/account/category">
              <el-icon>
                <CollectionTag />
              </el-icon>
              <span>账号分组</span>
            </el-menu-item>
            <el-menu-item index="/account/account">
              <el-icon>
                <User />
              </el-icon>
              <span>授权账号</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 7. 营销中心 (始终显示，内部菜单根据授权显示) -->
          <el-sub-menu index="marketing-group">
            <template #title>
              <el-icon>
                <Present />
              </el-icon>
              <span>营销中心</span>
            </template>
            <el-menu-item index="/marketing/activity">
              <el-icon>
                <Trophy />
              </el-icon>
              <span>活动管理</span>
            </el-menu-item>
            <el-menu-item index="/banner">
              <el-icon>
                <Picture />
              </el-icon>
              <span>轮播管理</span>
            </el-menu-item>
            <el-menu-item index="/home-recommend">
              <el-icon>
                <Star />
              </el-icon>
              <span>首页推荐</span>
            </el-menu-item>

            <el-menu-item index="/greenbook">
              <el-icon>
                <Notebook />
              </el-icon>
              <span>绿书营销</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 8. 预约管理 (始终显示) -->
          <el-sub-menu index="reservation-group">
            <template #title>
              <el-icon>
                <Calendar />
              </el-icon>
              <span>预约管理</span>
            </template>
            <el-menu-item index="/reservation/form">
              <el-icon>
                <Edit />
              </el-icon>
              <span>预约表单</span>
            </el-menu-item>
            <el-menu-item index="/reservation/record">
              <el-icon>
                <List />
              </el-icon>
              <span>预约记录</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 9. 分销管理 (始终显示) -->
          <el-sub-menu index="distributor-group">
            <template #title>
              <el-icon>
                <Share />
              </el-icon>
              <span>分销管理</span>
            </template>
            <el-menu-item index="/marketing/distributor">
              <el-icon>
                <User />
              </el-icon>
              <span>分销员管理</span>
            </el-menu-item>
            <el-menu-item index="/distributor-relation">
              <el-icon>
                <Connection />
              </el-icon>
              <span>分销关系</span>
            </el-menu-item>
            <el-menu-item index="/invite-record">
              <el-icon>
                <Message />
              </el-icon>
              <span>邀请记录</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 10. 会员管理 (始终显示) -->
          <el-sub-menu index="member-group">
            <template #title>
              <el-icon>
                <UserFilled />
              </el-icon>
              <span>会员管理</span>
            </template>
            <el-menu-item index="/member/list">
              <el-icon>
                <User />
              </el-icon>
              <span>会员列表</span>
            </el-menu-item>
            <el-menu-item index="/member/level">
              <el-icon>
                <Medal />
              </el-icon>
              <span>会员等级</span>
            </el-menu-item>
            <el-menu-item index="/member-sign">
              <el-icon>
                <Calendar />
              </el-icon>
              <span>会员签到</span>
            </el-menu-item>
            <el-menu-item index="/member/coupon">
              <el-icon>
                <Ticket />
              </el-icon>
              <span>优惠券管理</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 11. SEO配置 (需要 group_buy_mini_pro_video_jz 授权) -->
          <el-sub-menu index="seoconfig-group" v-if="pluginAuth.video_jz">
            <template #title>
              <el-icon>
                <Search />
              </el-icon>
              <span>SEO配置</span>
            </template>
            <el-menu-item index="/seoconfig/title">
              <el-icon>
                <Edit />
              </el-icon>
              <span>标题管理</span>
            </el-menu-item>
            <el-menu-item index="/seoconfig/desc">
              <el-icon>
                <Document />
              </el-icon>
              <span>描述管理</span>
            </el-menu-item>
            <el-menu-item index="/seoconfig/topic">
              <el-icon>
                <ChatDotRound />
              </el-icon>
              <span>话题管理</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 12. 视频剪辑 (需要 group_buy_mini_pro_video_hj 授权) -->
          <el-sub-menu index="videocut-group" v-if="pluginAuth.video_hj">
            <template #title>
              <el-icon>
                <VideoCamera />
              </el-icon>
              <span>视频剪辑</span>
            </template>
            <el-menu-item index="/videocut/video-cut">
              <el-icon>
                <MagicStick />
              </el-icon>
              <span>一键成片</span>
            </el-menu-item>
            <el-menu-item index="/videocut/wen-an">
              <el-icon>
                <Document />
              </el-icon>
              <span>文案管理</span>
            </el-menu-item>
            <el-menu-item index="/videocut/video-cp">
              <el-icon>
                <Film />
              </el-icon>
              <span>成片管理</span>
            </el-menu-item>
            <el-menu-item index="/videocut/video-wall">
              <el-icon>
                <Grid />
              </el-icon>
              <span>成片列表</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 13. 视频发布 (需要 group_buy_mini_pro_video_jz 授权) -->
          <el-sub-menu index="video-publish-group" v-if="pluginAuth.video_jz">
            <template #title>
              <el-icon>
                <Camera />
              </el-icon>
              <span>视频发布</span>
            </template>
            <el-menu-item index="/video_publish/draft">
              <el-icon>
                <DocumentCopy />
              </el-icon>
              <span>发布任务</span>
            </el-menu-item>
            <el-menu-item index="/video_publish/record">
              <el-icon>
                <Clock />
              </el-icon>
              <span>发布记录</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 14. 图文发布 (需要 group_buy_mini_pro_video_jz 授权) -->
          <el-sub-menu index="tw-publish-group" v-if="pluginAuth.video_jz">
            <template #title>
              <el-icon>
                <Files />
              </el-icon>
              <span>图文发布</span>
            </template>
            <el-menu-item index="/tw_publish/draft">
              <el-icon>
                <DocumentCopy />
              </el-icon>
              <span>发布任务</span>
            </el-menu-item>
            <el-menu-item index="/tw_publish/record">
              <el-icon>
                <Clock />
              </el-icon>
              <span>发布记录</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 15. 挂载管理 (需要 group_buy_mini_pro_video_jz 授权) -->
          <el-sub-menu index="mounting-group" v-if="pluginAuth.video_jz">
            <template #title>
              <el-icon>
                <Link />
              </el-icon>
              <span>挂载管理</span>
            </template>
            <el-menu-item index="/mounting/poi-gz">
              <el-icon>
                <Location />
              </el-icon>
              <span>地址挂载</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 16. 素材管理 (需要 group_buy_mini_pro_video_jz 授权) -->
          <el-sub-menu index="material-group" v-if="pluginAuth.video_jz">
            <template #title>
              <el-icon>
                <Picture />
              </el-icon>
              <span>素材管理</span>
            </template>
            <el-menu-item index="/material/gallery">
              <el-icon>
                <Picture />
              </el-icon>
              <span>图库管理</span>
            </el-menu-item>
            <el-menu-item index="/material/video-sc">
              <el-icon>
                <VideoCamera />
              </el-icon>
              <span>视频管理</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 17. 员工管理 (始终显示) -->
          <el-menu-item index="/staff">
            <el-icon>
              <User />
            </el-icon>
            <span>员工管理</span>
          </el-menu-item>

          <!-- 18. 系统设置 (创作指令需要 group_buy_mini_pro_video_jz 授权) -->
          <el-sub-menu index="system-group">
            <template #title>
              <el-icon>
                <Setting />
              </el-icon>
              <span>系统设置</span>
            </template>
            <el-menu-item index="/profile">
              <el-icon>
                <User />
              </el-icon>
              <span>个人中心</span>
            </el-menu-item>
            <!-- 创作指令需要 group_buy_mini_pro_video_jz 授权 -->
            <el-menu-item index="/system/command" v-if="pluginAuth.video_jz">
              <el-icon>
                <EditPen />
              </el-icon>
              <span>创作指令</span>
            </el-menu-item>
            <el-menu-item index="/channel-config">
              <el-icon>
                <Connection />
              </el-icon>
              <span>渠道配置</span>
            </el-menu-item>
            <el-menu-item index="/page-paths">
              <el-icon>
                <Files />
              </el-icon>
              <span>页面路径</span>
            </el-menu-item>
            <el-menu-item index="/pay-config">
              <el-icon>
                <Money />
              </el-icon>
              <span>支付配置</span>
            </el-menu-item>
            <el-menu-item index="/map-config">
              <el-icon>
                <Location />
              </el-icon>
              <span>地图配置</span>
            </el-menu-item>
            <el-menu-item index="/storage-config">
              <el-icon>
                <FolderOpened />
              </el-icon>
              <span>存储配置</span>
            </el-menu-item>
            <el-menu-item index="/ai-config">
              <el-icon>
                <Cpu />
              </el-icon>
              <span>接口配置</span>
            </el-menu-item>
            <!-- 在系统设置中，基础设置之后添加 -->
            <el-menu-item index="/consumption-log">
              <el-icon>
                <Document />
              </el-icon>
              <span>消费记录</span>
            </el-menu-item>
            <el-menu-item index="/base-config">
              <el-icon>
                <Tools />
              </el-icon>
              <span>基础设置</span>
            </el-menu-item>
          </el-sub-menu>

        </el-menu>
      </div>

      <div class="sidebar-footer" v-if="!isCollapsed">
        <div class="store-info">
          <el-icon>
            <OfficeBuilding />
          </el-icon>
          <span>{{ storeName }}</span>
        </div>
      </div>
    </aside>

    <!-- 主内容区 -->
    <div class="main-wrapper">
      <!-- 顶部导航 -->
      <header class="header">
        <div class="header-left">
          <el-icon class="collapse-icon" @click="toggleCollapse">
            <Fold v-if="!isCollapsed" />
            <Expand v-else />
          </el-icon>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-if="currentRoute">{{ currentRoute }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <div class="header-right">
          <div class="header-info">
            <div class="info-item points" v-if="dianshu !== null">
              <el-icon>
                <Coin />
              </el-icon>
              <span class="info-value">{{ dianshu === -1 ? '无限' : dianshu }} 点</span>
            </div>
            <div class="info-item auth" v-if="sqNum !== null">
              <el-icon>
                <Key />
              </el-icon>
              <span class="info-value">授权数: {{ sqNum === -1 ? '无限' : sqNum }}</span>
            </div>
            <el-tooltip :content="expireTooltip" placement="bottom" effect="dark" :disabled="!outDate">
              <div class="info-item expire" v-if="outDate">
                <el-icon>
                  <Calendar />
                </el-icon>
                <span class="info-value" :class="expireClass">{{ expireDisplayText }}</span>
              </div>
            </el-tooltip>
          </div>
          <el-badge :value="notificationCount" :hidden="notificationCount === 0" class="notification-badge">
            <el-icon class="header-icon" @click="goToOrder">
              <Bell />
            </el-icon>
          </el-badge>

          <el-dropdown trigger="click" @command="handleCommand">
            <div class="user-dropdown">
              <el-avatar :size="36" :src="userAvatar" class="user-avatar" />
              <span class="user-name">{{ userName }}</span>
              <el-icon>
                <ArrowDown />
              </el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="profile">
                  <el-icon>
                    <User />
                  </el-icon>个人中心
                </el-dropdown-item>
                <el-dropdown-item command="password">
                  <el-icon>
                    <Lock />
                  </el-icon>修改密码
                </el-dropdown-item>
                <el-dropdown-item divided command="logout">
                  <el-icon>
                    <SwitchButton />
                  </el-icon>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </header>

      <!-- 内容区域 -->
      <main class="content">
        <div class="content-card">
          <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
      </main>
    </div>

    <!-- 修改密码弹窗 -->
    <el-dialog v-model="showPasswordDialog" title="修改密码" width="420px" class="custom-dialog">
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordFormRef" label-width="80px">
        <el-form-item label="旧密码" prop="oldPwd">
          <el-input v-model="passwordForm.oldPwd" type="password" placeholder="请输入旧密码" show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input v-model="passwordForm.newPwd" type="password" placeholder="请输入新密码" show-password />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPwd">
          <el-input v-model="passwordForm.confirmPwd" type="password" placeholder="请再次输入新密码" show-password />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showPasswordDialog = false">取消</el-button>
        <el-button type="primary" @click="submitPassword" :loading="passwordLoading">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Cookies from 'js-cookie'
import axios from 'axios'
import config from '@/config'

// 图标导入
import {
  Odometer, Shop, House, Share, Goods, Collection, List, Plus, Setting,
  Document, Checked, Grid, CollectionTag, User, Present, Trophy, Picture,
  Star, Notebook, Calendar, Edit, Connection, Message, UserFilled, Medal,
  Ticket, Search, ChatDotRound, VideoCamera, MagicStick, Film, Camera,
  DocumentCopy, Clock, Files, Link, Location, FolderOpened, Cpu, Tools,
  Key, Coin, Bell, ArrowDown, Lock, SwitchButton, OfficeBuilding, Fold,
  Expand, EditPen, Money
} from '@element-plus/icons-vue'

const router = useRouter()
const route = useRoute()
const shopLogo = ref('@/assets/logo.png')
const shopName = ref('商户端')
const isCollapsed = ref(false)

// 用户资源
const dianshu = ref(null)
const sqNum = ref(null)
const outDate = ref('')

// 插件授权状态
const pluginAuth = ref({
  sph_tg: false,      // group_buy_mini_pro_sph_tg (绿书营销)
  video_ai: false,    // group_buy_mini_pro_video_ai
  video_hj: false,    // group_buy_mini_pro_video_hj (视频剪辑)
  video_jz: false     // group_buy_mini_pro_video_jz (矩阵相关功能)
})

// 用户信息
const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
const userName = ref(userInfo.account || '管理员')
const userAvatar = ref('https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png')
const storeName = ref(userInfo.nickName)
const notificationCount = ref(0)

let timerId = null

// 当前路由标题
const currentRoute = computed(() => {
  const matched = route.matched
  if (matched.length > 1) {
    return matched[matched.length - 1].meta?.title || matched[matched.length - 1].name
  }
  return ''
})

// 激活的菜单项
const activeMenu = computed(() => route.path)

// 修改密码相关
const showPasswordDialog = ref(false)
const passwordLoading = ref(false)
const passwordFormRef = ref(null)
const passwordForm = ref({
  oldPwd: '',
  newPwd: '',
  confirmPwd: ''
})

const passwordRules = {
  oldPwd: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
  newPwd: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
  ],
  confirmPwd: [
    { required: true, message: '请确认新密码', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value !== passwordForm.value.newPwd) {
          callback(new Error('两次输入密码不一致'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ]
}

// 剩余天数
const remainingDays = computed(() => {
  if (!outDate.value) return null
  const now = new Date()
  now.setHours(0, 0, 0, 0)
  const expire = new Date(outDate.value)
  expire.setHours(0, 0, 0, 0)
  const diffTime = expire - now
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return diffDays
})

// 过期样式类
const expireClass = computed(() => {
  if (!outDate.value) return ''
  const days = remainingDays.value
  if (days < 0) return 'expired'
  if (days <= 7) return 'expiring-soon'
  if (days <= 30) return 'expiring'
  return 'normal'
})

// 过期显示文本
const expireDisplayText = computed(() => {
  if (!outDate.value) return ''
  const days = remainingDays.value
  const expireDate = formatExpireDate(outDate.value)

  if (days < 0) {
    return `已过期 ${Math.abs(days)} 天`
  }
  if (days === 0) {
    return '今日到期'
  }
  if (days <= 30) {
    return `${expireDate} (剩${days}天)`
  }
  return `${expireDate}`
})

// 过期提示内容
const expireTooltip = computed(() => {
  if (!outDate.value) return ''
  const days = remainingDays.value
  const expireDate = formatExpireDate(outDate.value)

  if (days < 0) {
    return `账号已于 ${expireDate} 过期，请联系管理员续费`
  }
  if (days === 0) {
    return '账号将于今日到期，请及时续费'
  }
  if (days <= 7) {
    return `账号将于 ${expireDate} 到期，剩余 ${days} 天，请尽快续费`
  }
  if (days <= 30) {
    return `账号将于 ${expireDate} 到期，剩余 ${days} 天`
  }
  return `账号有效期至 ${expireDate}，剩余 ${days} 天`
})

const formatExpireDate = (dateStr) => {
  if (!dateStr) return ''
  try {
    const match = dateStr.match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})/)
    if (match) {
      const year = match[1]
      const month = match[2]
      const day = match[3]
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    }
    return dateStr
  } catch (error) {
    return dateStr
  }
}

// 获取用户信息（点数和授权数）
const fetchUserInfo = async () => {
  try {
    const agentId = userInfo.agent_id || 0
    const storeId = userInfo.id

    const response = await axios.get(`${config.BASE_URL}/shop/api/profile_api.php`, {
      params: {
        agent_id: agentId,
        store_id: storeId
      }
    })

    if (response.data.code === 200 && response.data.data) {
      const data = response.data.data
      dianshu.value = data.dianshu || 0
      sqNum.value = data.sq_num || 0
      outDate.value = data.out_date || ''

      // 解析 application_market
      if (data.application_market) {
        let market = {}
        if (typeof data.application_market === 'string') {
          try {
            market = JSON.parse(data.application_market)
          } catch (e) {
            console.error('解析 application_market 失败:', e)
          }
        } else {
          market = data.application_market
        }

        pluginAuth.value = {
          sph_tg: market.group_buy_mini_pro_sph_tg === true,
          video_ai: market.group_buy_mini_pro_video_ai === true,
          video_hj: market.group_buy_mini_pro_video_hj === true,
          video_jz: market.group_buy_mini_pro_video_jz === true
        }
      }

      const updatedInfo = { ...userInfo, ...data }
      Cookies.set('user_info', JSON.stringify(updatedInfo), { expires: 7 })
    }
  } catch (error) {
    console.error('获取用户信息失败:', error)
  }
}

// 获取通知数量
const fetchNotificationCount = async () => {
  try {
    const agentId = userInfo.agent_id || 0
    const storeId = userInfo.id

    const response = await axios.get(`${config.BASE_URL}/shop/api/order_api.php`, {
      params: {
        agent_id: agentId,
        store_id: storeId,
        page: 1,
        limit: 100
      }
    })

    if (response.data.code === 200 && response.data.data.list) {
      const orders = response.data.data.list
      const pendingPayCount = orders.filter(order => order.pay_status === 0 && order.order_status === 0).length
      const pendingUseCount = orders.filter(order => order.pay_status === 1 && order.order_status === 1).length
      notificationCount.value = pendingPayCount + pendingUseCount
    } else if (response.data.code === 200 && response.data.data.stats) {
      const stats = response.data.data.stats
      notificationCount.value = (stats.pending_pay || 0) + (stats.pending_use || 0)
    } else {
      notificationCount.value = 0
    }
  } catch (error) {
    console.error('获取通知数量失败:', error)
    notificationCount.value = 0
  }
}

// 跳转到订单页面
const goToOrder = () => {
  router.push('/order')
}

// 切换侧边栏
const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value
}

// 下拉菜单命令
const handleCommand = (command) => {
  switch (command) {
    case 'profile':
      router.push('/profile')
      break
    case 'password':
      showPasswordDialog.value = true
      break
    case 'logout':
      handleLogout()
      break
  }
}

// 退出登录
const handleLogout = async () => {
  try {
    await ElMessageBox.confirm('确定要退出登录吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    Cookies.remove('user_token')
    Cookies.remove('user_info')
    router.push('/login')
    ElMessage.success('已退出登录')
  } catch (error) {
    // 取消退出
  }
}

// 修改密码
const submitPassword = async () => {
  if (!passwordFormRef.value) return

  await passwordFormRef.value.validate(async (valid) => {
    if (!valid) return

    passwordLoading.value = true
    try {
      const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
        action: 'update_password',
        account: userInfo.account,
        old_password: passwordForm.value.oldPwd,
        new_password: passwordForm.value.newPwd
      })

      if (response.data.success) {
        ElMessage.success('密码修改成功，请重新登录')
        showPasswordDialog.value = false
        setTimeout(() => {
          handleLogout()
        }, 1500)
      } else {
        ElMessage.error(response.data.message || '密码修改失败')
      }
    } catch (error) {
      ElMessage.error('请求失败，请稍后重试')
    } finally {
      passwordLoading.value = false
    }
  })
}

// 加载店铺信息
const loadShopInfo = async () => {
  try {
    const currentDomain = window.location.hostname
    const response = await axios.get(`${config.BASE_URL}/shop/api/web_icon.php`, {
      params: {
        domain: currentDomain
      }
    })

    if (response.data.success) {
      shopLogo.value = response.data.data.shop_logo || '@/assets/logo.gif'
      shopName.value = response.data.data.shop_name || '商户端'
    }
  } catch (error) {
    console.error('加载店铺信息失败:', error)
    shopLogo.value = '@/assets/logo.gif'
    shopName.value = '商户端'
  }
}

onMounted(() => {
  loadShopInfo()
  fetchNotificationCount()
  fetchUserInfo()
  timerId = setInterval(() => {
    fetchNotificationCount()
  }, 30000)
})

onUnmounted(() => {
  if (timerId) {
    clearInterval(timerId)
  }
})
</script>

<style scoped lang="scss">
.app-layout {
  display: flex;
  min-height: 100vh;
  background: #f0f2f6;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-right: 20px;
  padding-right: 20px;
  border-right: 1px solid #e8e8e8;

  .info-item {
    display: flex;
    align-items: center;
    gap: 6px;

    .el-icon {
      font-size: 18px;
    }

    .info-value {
      font-size: 14px;
      color: #333;
      font-weight: 500;

      &.expiring-soon {
        color: #f56c6c;
      }
    }

    &.points .el-icon {
      color: #409eff;
    }

    &.auth .el-icon {
      color: #67c23a;
    }

    &.expire .el-icon {
      color: #e6a23c;
    }
  }
}

// 侧边栏样式
.sidebar {
  width: 260px;
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  display: flex;
  flex-direction: column;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
  overflow: hidden;

  &.sidebar-collapsed {
    width: 64px;

    .logo-text {
      display: none;
    }

    .store-info span {
      display: none;
    }
  }

  .logo-area {
    display: flex;
    align-items: center;
    padding: 20px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    flex-shrink: 0;

    .logo-img {
      width: 36px;
      height: 36px;
      border-radius: 8px;
      flex-shrink: 0;
    }

    .logo-text {
      margin-left: 12px;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      white-space: nowrap;
    }
  }

  .sidebar-menu-wrapper {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.1);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.3);
      border-radius: 4px;

      &:hover {
        background: rgba(255, 255, 255, 0.5);
      }
    }
  }

  .sidebar-menu {
    border: none;
    background: transparent !important;
    padding: 16px 12px;

    &:not(.el-menu--collapse) {
      width: 100%;
    }

    :deep(.el-menu) {
      background: transparent !important;
    }

    :deep(.el-menu-item),
    :deep(.el-sub-menu .el-sub-menu__title) {
      height: 48px;
      line-height: 48px;
      color: rgba(255, 255, 255, 0.7);
      border-radius: 12px;
      margin-bottom: 4px;
      background: transparent !important;

      &:hover {
        background: rgba(255, 255, 255, 0.1) !important;
        color: #fff;
      }

      &.is-active {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
        color: #fff;
      }

      .el-icon {
        font-size: 20px;
        margin-right: 12px;
      }
    }

    :deep(.el-sub-menu) {
      .el-menu {
        background: transparent !important;
      }

      .el-menu-item {
        padding-left: 52px !important;
        background: transparent !important;

        &:hover {
          background: rgba(255, 255, 255, 0.08) !important;
        }

        &.is-active {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
        }
      }
    }

    :deep(.el-popper) {
      .el-menu--popup {
        background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%) !important;
        border: none;

        .el-menu-item {
          background: transparent !important;
          color: rgba(255, 255, 255, 0.7);

          &:hover {
            background: rgba(255, 255, 255, 0.1) !important;
            color: #fff;
          }

          &.is-active {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
            color: #fff;
          }
        }
      }
    }
  }

  .sidebar-footer {
    padding: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    flex-shrink: 0;

    .store-info {
      display: flex;
      align-items: center;
      color: rgba(255, 255, 255, 0.6);
      font-size: 13px;

      .el-icon {
        margin-right: 8px;
        font-size: 16px;
      }

      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

// 主内容区样式
.main-wrapper {
  flex: 1;
  margin-left: 260px;
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex; // 新增
  flex-direction: column; // 新增
  min-width: 0; // 👈 核心！阻止 flex 子元素撑大父容器
  overflow: hidden; // 👈 裁剪溢出内容
}

// 头部样式
.header {
  height: 60px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  position: sticky;
  top: 0;
  z-index: 99;

  .header-left {
    display: flex;
    align-items: center;
    gap: 20px;

    .collapse-icon {
      font-size: 20px;
      cursor: pointer;
      color: #666;
      transition: all 0.3s;

      &:hover {
        color: #667eea;
      }
    }

    :deep(.el-breadcrumb) {
      font-size: 14px;

      .el-breadcrumb__inner {
        color: #666;

        &.is-link:hover {
          color: #667eea;
        }
      }

      .el-breadcrumb__item:last-child .el-breadcrumb__inner {
        color: #333;
        font-weight: 500;
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 24px;

    .notification-badge {
      cursor: pointer;

      :deep(.el-badge__content) {
        background-color: #f56c6c;
      }
    }

    .header-icon {
      font-size: 20px;
      color: #666;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        color: #667eea;
      }
    }

    .user-dropdown {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      padding: 4px 12px;
      border-radius: 24px;
      transition: background 0.3s;

      &:hover {
        background: #f5f5f5;
      }

      .user-avatar {
        border: 2px solid #e0e0e0;
      }

      .user-name {
        font-size: 14px;
        color: #333;
      }

      .el-icon {
        font-size: 16px;
        color: #999;
      }
    }
  }
}

// 找到 .content，补充 overflow
.content {
  padding: 24px;
  min-height: calc(100vh - 60px);
  flex: 1; // 新增
  overflow: hidden; // 👈 新增，防止内容溢出

  .content-card {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    padding: 24px;
    min-height: calc(100vh - 108px);
    overflow: hidden; // 👈 新增，防止内容溢出
  }
}

// 动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

// 响应式
@media (max-width: 768px) {
  .sidebar {
    width: 64px;

    .logo-text,
    .store-info span {
      display: none;
    }
  }

  .main-wrapper {
    margin-left: 64px;
  }

  .header {
    padding: 0 16px;

    .user-dropdown .user-name {
      display: none;
    }
  }

  .content {
    padding: 16px;

    .content-card {
      padding: 16px;
    }
  }
}
</style>